import { StringUtil } from './StringUtil'

export class UnitUtil {
  public static sign(
    _value: number,
    _signs?: {
      positive?: string
      negative?: string
    }
  ) {
    const signs = {
      positive: '+',
      negative: '',
      ...(_signs || {}),
    }

    return _value > 0 ? signs.positive : signs.negative
  }

  public static yuan(fen: number, precision = 2) {
    return +(fen / 100.0).toFixed(precision)
  }

  public static rate(amount: number, totalAmount: number) {
    const result = amount / (totalAmount || 1.0)
    if (result <= 0) return 0
    if (result > 1) return 1
    return result
  }

  public static percent(decimal: number, precision = 2) {
    return +(decimal * 100).toFixed(precision)
  }

  public static toFixed(value: number, precision = 2) {
    return +(value || 0).toFixed(precision)
  }

  public static division(amount: number, base: number, precision = 2) {
    return this.toFixed(amount / (base || 1.0), precision)
  }

  public static transform(amount: number, base: number, unit: string, precision = 2) {
    return amount && amount > base ? `${this.division(amount, base, precision)}${unit}` : amount
  }

  public static formatNumberToWan(_value: number) {
    const totalShortBase = 10000
    const count = _value || 0

    return count > totalShortBase
      ? `${StringUtil.formatNumberWithCommas(this.toFixed(this.division(count, totalShortBase), 2))}万`
      : StringUtil.formatNumberWithCommas(count)
  }

  public static ratePercent(amount: number, totalAmount: number, precision = 2) {
    return this.percent(this.rate(amount, totalAmount), precision)
  }

  public static roundRatePercent(amount: number, totalAmount: number, precision = 1) {
    const rate = this.rate(amount, totalAmount)
    if (rate <= 0) return 0
    if (rate >= 100) return 100
    return this.percent(rate, precision)
  }
}
